/* ==========================================================================
   department-grid.js — the products on the shelf take turns.

   Each department slot holds up to three product pictures stacked; one is
   current. Every few seconds ONE slot — the next one along — swaps its
   picture, so across eight the shelf is always gently changing but never
   busy. It runs only while the shelf is on screen, never in a hidden tab,
   and not at all for anyone who has asked for reduced motion. A hovered
   slot keeps the picture it is showing.
   ========================================================================== */
(function () {
  'use strict';

  var INTERVAL_MS = 2800;

  function boot() {
    var grid = document.querySelector('[data-dept-grid]');
    if (!grid || grid.dataset.cycling) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var slots = Array.prototype.filter.call(grid.querySelectorAll('.dept__link'), function (slot) {
      return slot.querySelectorAll('.dept__product').length > 1;
    });
    if (!slots.length) return;
    grid.dataset.cycling = '1';

    var onScreen = true;
    var next = 0;

    function advance(slot) {
      var pics = slot.querySelectorAll('.dept__product');
      var current = slot.querySelector('.dept__product.is-current');
      var index = Array.prototype.indexOf.call(pics, current);
      if (current) current.classList.remove('is-current');
      pics[(index + 1) % pics.length].classList.add('is-current');
    }

    function tick() {
      if (!onScreen || document.visibilityState !== 'visible') return;
      var slot = slots[next % slots.length];
      next += 1;
      if (slot.matches(':hover')) return;
      advance(slot);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
      }, { threshold: 0.2 }).observe(grid);
    }

    setInterval(tick, INTERVAL_MS);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
